const LANGUAGE = document.documentElement.getAttribute('lang')

export function langifyUrl(url) {
  if (url[0] !== '/') return

  return `/${LANGUAGE}${url}`
}



// WEBPACK FOOTER //
// ./src/js/shared/utils/functions.js